import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useClientStore = defineStore('client', () => {
    const all = ref({ data: [] });
    const active = ref({});
    const clientSupportPlans = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = async (params) => {
        return axios.get('/api/v1/clients', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/clients', params);
    };

    const updateClientProfile = async (params) => {
        return axios.patch(`/api/v1/clients/${params.hash}/profile`, params);
    };

    const updateIntakeTour = async (params) => {
        return axios.patch(`/api/v1/clients/${params.client_hash}/intake-tour/${params.intake_tour_hash}`, params);
    };

    const update = async (params) => {
        return axios.patch(`/api/v1/clients/${params.hash}`, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/clients/' + params.hash);
    };

    const searchClientSupportPlan = async (params) => {
        return axios.get(`/api/v1/clients/${params.hash}/support-plans`, { params });
    };

    return {
        active,
        all,
        reset,
        search,
        store,
        updateClientProfile,
        updateIntakeTour,
        searchClientSupportPlan,
        clientSupportPlans,
        update,
        destroy,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useClientStore, import.meta.hot));
}
